export const transformToSlug = (name: string): string => {
  return (
    (name || '')
      .trim()
      // Replace all non-alphanumeric characters with a dash
      .replace(/[^a-zA-Z0-9]/g, '-')
      // Replace multiple consecutive dashes with a single dash
      .replace(/-+/g, '-')
      // Remove leading and trailing dashes
      .replace(/^-+|-+$/g, '')
      .toLowerCase()
  );
};
